import React, { useState, useEffect } from "react";
import {
    Tab,
    Tabs,
    Typography,
    CardMedia,
    Grid,
    Box,
} from "@material-ui/core";

import useStyles from "./styles";
import TopSpacer from "../../../../components/Common/spacer/TopSpacer";
import Breadcrumbs from "../../../../components/BreadCrums/breadcrums";
import DetailPage from "./detailPage/DetailPage";
import Documents from "../programDetails/proposalDocuments/ProposalDocuments";
import PhotoGallery from "./photoGallery/PhotoGallery";
import { PostDataAPI } from "../../../../Services/APIService";
import GrantReceived from "./grantReceived/GrantReceived";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}



function ProgramDetails({ closeProgramDetails, programId, ...props }) {
    const classes = useStyles();
    const [value, setValue] = useState(0)

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    
    const [loader, setloader] = useState();

    const [programData, setProgramData] = useState();


    const loadProgramDetail = () => {
        let obj = {
            programId: programId
        }
        PostDataAPI("fdngrantprograms/get", obj).then((result) => {
            if (result.success && result.data != null) {
    
                console.log(result.data);
                setProgramData(result.data);
            }
            else {
                setProgramData([]);
            }

        })
    }


    useEffect(() => {
        loadProgramDetail();
    }, [])

    return (
        <>

            <div className={classes.header}>
                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrumbs
                            parentLink={"Program"}
                            currentLink={programData?.name}
                            gobackAction={closeProgramDetails}
                            isBack={true} />
                    </Grid>
                </Grid>
            </div>
            <div className={classes.tabcontainer}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="full width tabs example"
                >
                    <Tab label="Program Details" {...a11yProps(0)} />
                    <Tab label="Program Documentations" {...a11yProps(1)} />
                    <Tab label="Photo Gallery" {...a11yProps(2)} />
                    <Tab label="Grant Received" {...a11yProps(3)} />

                </Tabs>

                <TabPanel value={value} index={0}>
                    <DetailPage programData={programData}></DetailPage>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Documents programData={programData}></Documents>
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <PhotoGallery programData={programData}></PhotoGallery>
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <GrantReceived programData={programData}></GrantReceived>
                </TabPanel>
            </div>

        </>
    )
}

export default ProgramDetails;